export default {
  form: {
    amount: {
      label: 'Precio',
    },
    threshold: {
      label: 'Ventas mensuales',
    },
    has_pricing_tiers: {
      label: 'El precio varía según las ventas mensuales',
    },
    tax_included: {
      label: 'Impuesto incluido',
    },
  },
  buttons: {
    add_tier: 'Agregar nivel',
  },
};
